import { render, staticRenderFns } from "./FragmentEmbed.vue?vue&type=template&id=03f3fa98"
import script from "./FragmentEmbed.vue?vue&type=script&lang=ts"
export * from "./FragmentEmbed.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports